/**
 * Copyright (C) 2021 - 2022 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'not-found-container',
	templateUrl: './not-found-container.component.html',
	styleUrls: ['./not-found-container.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class NotFoundContainerComponent {}
